import React from "react";
import {ChipDelete, CircularProgress, Stack,} from "@mui/joy";
import Typography from "@mui/joy/Typography";
import Chip from "@mui/joy/Chip";
import Divider from "@mui/joy/Divider";

// components
import UserSubscriberContext from "../../../context/UserSubscriberContext";
import TeamCreate from "./TeamCreate";
import BaseApi from "../../../utils/BaseApi";
import retrievePermission from "../../../utils/retrievePermission";
import ProfileHorizontalByProps from "../../Profile/ProfileHorizontalByProps";

// icons
import LensIcon from '@mui/icons-material/Lens';


class TeamTab extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            team: null,
            teamDeleted: null,
            updatePermission: 0,
            destroyPermission: 0,
        };
    }

    async componentDidMount() {
        await this.retrieveTeam();
        await this.retrieveUpdatePermission();
        await this.retrieveDestroyPermission();
    }

    async retrieveDestroyPermission() {
        let p = await retrievePermission(
            'OppTeamViewSet',
            'destroy',
            this.context.subscriberObject
        )
        this.setState(
            {
                destroyPermission: p,
            }
        )
    }

    async retrieveUpdatePermission() {
        let p = await retrievePermission(
            'OppTeamViewSet',
            'partial_update',
            this.context.subscriberObject
        );
        this.setState(
            {
                updatePermission: p
            }
        );
    }

    async retrieveTeam() {
        const url = `opp_team/`;
        const api = new BaseApi();
        let users = {}
        let params = {
            opportunity: this.props.opportunity.id,
            ordering: 'id',
            deleted: false,
        };
        let response = await api.get(url, params);
        let team = response.data.results
        let teamDict = {}
        for (let mate of team){
            if (teamDict[mate.subscriber.user.id]){
                teamDict[mate.subscriber.user.id].push(mate)
            }
            else {
                teamDict[mate.subscriber.user.id] = [mate, ]
            }
            users[mate.subscriber.user.id] = mate.subscriber.user
        }
        params = {
            opportunity: this.props.opportunity.id,
            ordering: 'id',
            deleted: true,
        };
        response = await api.get(url, params);
        let teamDeleted = response.data.results
        let teamDeletedDict = {}
        for (let mate of teamDeleted){
            if (teamDeletedDict[mate.subscriber.user.id]){
                teamDeletedDict[mate.subscriber.user.id].push(mate)
            }
            else {
                teamDeletedDict[mate.subscriber.user.id] = [mate, ]
            }
            users[mate.subscriber.user.id] = mate.subscriber.user
        }
        this.setState(
            {
                team: teamDict,
                teamDeleted: teamDeletedDict,
                users: users,
            }
        );
    }

    async destroy(id) {
        const url = `opp_team/${id}/`;
        const api = new BaseApi();
        await api.delete(url, {});
        await this.retrieveTeam();
    }

    async setActive(id, active){
        const url = `opp_team/${id}/`;
        const api = new BaseApi();
        await api.patch(
            url,
            {
                active: !active
            }
        );
        await this.retrieveTeam();
    }

    render() {
        if (!this.state.team || !this.state.teamDeleted || !this.state.users) {
            return (<CircularProgress/>)
        }
        return (
            <Stack
                sx={{
                    width: '100%'
                }}
                spacing={2}
            >
                <Stack
                    direction={'row'}
                    spacing={1}
                    sx={{
                        width: '100%',
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}

                >
                    <Typography
                        level="h4"
                    >
                        Текущие участники
                    </Typography>
                    {
                        this.state.updatePermission?
                            <TeamCreate
                                opportunity={this.props.opportunity}
                                callBack={this.retrieveTeam.bind(this)}
                            />:
                            null
                    }

                </Stack>
                <Stack
                    sx={{
                        width: '100%',

                    }}
                    spacing={1}
                >
                    {Object.keys(this.state.team).map(
                        (key) => (
                            <>
                                <Stack
                                    direction={'row'}
                                    spacing={1}
                                    sx={{
                                        width: '100%',
                                        alignItems: "flex-start",
                                    }}
                                >
                                    <Stack
                                        direction={'row'}
                                        spacing={1}
                                        useFlexGap
                                        sx={{
                                            flexWrap: 'wrap',
                                            width: '20%',
                                        }}
                                    >
                                        <ProfileHorizontalByProps
                                            user={this.state.users[key]}
                                        />
                                    </Stack>
                                    <Stack
                                        direction={'row'}
                                        spacing={1}
                                        useFlexGap
                                        sx={{
                                            flexWrap: 'wrap',
                                            width: '80%',
                                        }}
                                    >
                                        {this.state.team[key].map((role) => (
                                            <Chip
                                                size={'sm'}
                                                color={role.color}
                                                endDecorator={
                                                    <ChipDelete
                                                        onDelete={this.destroy.bind(this, role.id)}
                                                    />
                                                }
                                                startDecorator={<LensIcon color={role.active?'success':'warning'}/>}
                                                onClick={this.setActive.bind(this, role.id, role.active)}
                                            >
                                                {role.role_human}
                                            </Chip>
                                        ))}
                                    </Stack>
                                </Stack>
                                <Divider />
                            </>
                        )
                    )}
                </Stack>
                <Typography
                    level="h4"
                >
                    Архивные участники участники
                </Typography>
                <Stack
                    sx={{
                        width: '100%'
                    }}
                    spacing={1}
                >
                    {Object.keys(this.state.teamDeleted).map(
                        (key) => (
                            <>
                                <Stack
                                    direction={'row'}
                                    spacing={1}
                                    sx={{
                                        width: '100%',
                                        alignItems: "flex-start",
                                    }}
                                >
                                    <Stack
                                        direction={'row'}
                                        spacing={1}
                                        useFlexGap
                                        sx={{
                                            flexWrap: 'wrap',
                                            width: '20%',
                                        }}
                                    >
                                        <ProfileHorizontalByProps
                                            user={this.state.users[key]}
                                        />
                                    </Stack>
                                    <Stack
                                        direction={'row'}
                                        spacing={1}
                                        useFlexGap
                                        sx={{
                                            flexWrap: 'wrap',
                                            width: '80%',
                                        }}
                                    >
                                        {this.state.teamDeleted[key].map((role) => (
                                            <Chip
                                                size={'sm'}
                                                color={role.color}
                                            >
                                                {role.role_human} (до: {role.updated_on.split(' ')[0]})
                                            </Chip>
                                        ))}
                                    </Stack>
                                </Stack>
                                <Divider />
                            </>
                        )
                    )}
                </Stack>
            </Stack>

        )
    }
}

export default TeamTab
